import React, { useContext, useRef, useState } from 'react';
import {
    BaseEdge,
    EdgeLabelRenderer,
    getBezierPath,
    useReactFlow,
    type EdgeProps,
} from '@xyflow/react';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import { isCurrentViewVersionPublished } from '../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore';

export default function CustomEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
}: EdgeProps) {
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });
    const { setUpdatedEdges, updateNodeFlow, edges, nodes, removeFlagStartNode } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const [hoveredEdge, setHoveredEdge] = useState<string>("");
    const [hoveredEdgeFlag, setHoveredEdgeFlag] = useState<boolean>(false);
    const flagInteractiveCanvas = useFlowBuilderStore((state) => state.flagInteractiveCanvas);

    const onEdgeClick = () => {
        setHoveredEdge("");
        let edgeToBeDeleted = edges.find((edge: any) => edge.id == id)
        let triggerNode = nodes.find((node: any) => node.type == 'trigger');
        if (triggerNode.id == edgeToBeDeleted.source) {
            let targetNode = nodes.find((node: any) => node.id == edgeToBeDeleted.target);
            setUpdatedEdges({
                actionType: "deleteEdge",
                edgeToBeDeleted: id
            },
                nodes,
                edges);
            removeFlagStartNode(targetNode)
        } else {
            setUpdatedEdges({
                actionType: "deleteEdge",
                edgeToBeDeleted: id
            },
                nodes,
                edges);

            updateNodeFlow({
                actionType: "deleteEdge",
                edgeToBeDeleted: id,
                edgeData: edges.find((edge: any) => edge.id == id)
            },
                nodes,
                edges)
        }

    };

    const handleMouseEnter = () => {
        if (hoveredEdge != id) {
            setHoveredEdge(id)
        }
    };

    const handleMouseLeave = () => {  
        setTimeout(() => {
            setHoveredEdge("")
        }, 200);
    };

    return (
        <>
            {/* <BaseEdge 
                path={edgePath} 
                markerEnd={markerEnd} 
                style={style}
            /> */}

            <path
                id={id}
                d={edgePath}
                style={{
                    ...style,
                    fill: 'none',
                    stroke: (hoveredEdge == id || hoveredEdgeFlag) ? "#222" : "#918D8D",
                    strokeWidth: 1.5,
                    cursor: "pointer",
                }}
                markerEnd={markerEnd}
                onMouseEnter={() => {
                    handleMouseEnter();
                }}
                onMouseLeave={() => {
                    handleMouseLeave();
                }}
            />
            {/* {(hoveredEdge == id || hoveredEdgeFlag) &&  */}
            <EdgeLabelRenderer>
                <div
                    className={`${(hoveredEdge == id || hoveredEdgeFlag) ? "button-edge__label-visible" : "button-edge__label-not-visible"} button-edge__label nodrag nopan`}
                    style={{
                        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                    }}
                    onMouseEnter={() => { if(flagInteractiveCanvas) setHoveredEdgeFlag(true); }}
                    onMouseLeave={() => { if(flagInteractiveCanvas) setHoveredEdgeFlag(false); }}
                >
                    {!isCurrentViewVersionPublished(currentActiveStaticWorkflow) &&
                        <button className="button-edge__button" onClick={() =>  {
                            if(flagInteractiveCanvas){
                                onEdgeClick()
                            }
                        }}>
                            ×
                        </button>}
                </div>
            </EdgeLabelRenderer>
            {/* }  */}
        </>
    );
}